import { createSlice } from '@reduxjs/toolkit'

type initialProps = {
  boolean: boolean
  spots: [
    {
      address: string
      id: number
      name: string
      zip: string
    },
  ]
}

const initialState: initialProps = {
  boolean: false,
  spots: [
    {
      address: '',
      id: null,
      name: '',
      zip: '',
    },
  ],
}

const dialogGroupSpotsReducer = createSlice({
  name: 'dialogGroupSpots',
  initialState: initialState,
  reducers: {
    dialogGroupSpotsState(state, action) {
      state.boolean = action.payload
    },
    groupSpotsState(state, action) {
      state.spots = action.payload
    },
  },
})

export const { dialogGroupSpotsState, groupSpotsState } = dialogGroupSpotsReducer.actions

export default dialogGroupSpotsReducer.reducer
